import { getPermissionByName } from './customMethods';

// First page a vendor lands on after signing in, based on their permissions.
export const landingRoute = () => {
    if (getPermissionByName('dashboard')) return '/dashboard';
    if (getPermissionByName('map')) return '/map';
    if (getPermissionByName('search')) return '/search';
    if (getPermissionByName('reports')) return '/ars-usage-report';
    if (getPermissionByName('towSheets')) return '/home';
    return '/';
};
